<template>
  <MyOrdersStatusInfoButton
    v-if="isInfoButtonVisible"
    v-bind="{ status }"
    class="mr-200"
    type="highfrequency"
  />
  <MyOrdersStatusBadgeHighFrequency v-if="isBadgeVisible" v-bind="{ count, status }" />
</template>

<script lang="ts" setup>
import { HighFrequency_OrderStatus } from '#api/shared/@types/generated/backend/graphql-schema-types'

import { HighFrequency_OrderStatusActive } from '../utils/types'

type MyOrdersStatusProps = {
  count?: number
  status: HighFrequency_OrderStatus | HighFrequency_OrderStatusActive
}

const { status } = defineProps<MyOrdersStatusProps>()

const isBadgeVisible = computed(() => status !== HighFrequency_OrderStatus.Finished)
const isInfoButtonVisible = computed(
  () =>
    ![
      HighFrequency_OrderStatus.Cancelled,
      HighFrequency_OrderStatus.Finished,
      HighFrequency_OrderStatusActive.Ready,
    ].includes(status as HighFrequency_OrderStatus | HighFrequency_OrderStatusActive),
)
</script>
